import api from '../../api';

const state = {
  attendance: [],
  cancellation: [],
  pulseLaunch: [],
  inviteResetPositive: [],
  inviteResetNegative: [],
  subscriptionStatus: '',
  tempSubAlert: false,
};

// getters
const getters = {
  hasAttendances: (state) => (state.attendance.length > 0),
  hasCancellations: (state) => (state.cancellation.length > 0),
  hasPulseLaunch: (state) => (state.pulseLaunch.length > 0),
  hasInviteResetPositive: (state) => (state.inviteResetPositive.length > 0),
  hasInviteResetNegative: (state) => (state.inviteResetNegative.length > 0),
};

// mutations
const mutations = {
  removeData(state) {
    state.attendance = [];
    state.cancellation = [];
  },

  setData(state, {
    attendance, cancellation, pulseLaunch, inviteResetPositive, inviteResetNegative,
    subscriptionStatus, tempSubAlert,
  }) {
    state.attendance = attendance || [];
    state.cancellation = cancellation || [];
    state.pulseLaunch = pulseLaunch || [];
    state.inviteResetPositive = inviteResetPositive || [];
    state.inviteResetNegative = inviteResetNegative || [];
    state.subscriptionStatus = subscriptionStatus || '';
    state.tempSubAlert = tempSubAlert || false;
  },

  addOneAlert(state, { type, data }) {
    if (['attendance', 'cancellation'].includes(type)) {
      state[type].push(data);
    }
  },

  removeSingleAttendance(state, id) {
    state.attendance = state.attendance.filter((el) => el.uuid !== id);
  },

  removeSingleCancellation(state, id) {
    state.cancellation = state.cancellation.filter((el) => el.uuid !== id);
  },

  removeSinglePulseLaunch(state, id) {
    state.pulseLaunch = state.pulseLaunch.filter((el) => el.uuid !== id);
  },
};

// actions
const actions = {
  async fetchCoachAlerts({ commit }) {
    // empty data
    commit('removeData');

    try {
      const response = await api.getCoachAlerts();
      commit('setData', {
        attendance: response.data.attendance,
        cancellation: response.data.cancellation,
        pulseLaunch: response.data.pulse_launch,
        inviteResetPositive: response.data.invite_reset_positive,
        inviteResetNegative: response.data.invite_reset_negative,
        subscriptionStatus: response.data.subscription_status,
        tempSubAlert: response.data.temp_sub_alert,
      });
      return response.data;
    } catch (err) {
      console.log(err);
      if (err.msg) {
        console.log(err.msg);
      }
      return null;
    }
  },

  alertChanged({ commit }, data) {
    if (data && data.type) {
      switch (data.type) {
        case 'Attendance':
          commit('removeSingleAttendance', data.uuid);
          break;
        case 'Cancellation':
          commit('removeSingleCancellation', data.uuid);
          break;
        case 'PulseLaunch':
          commit('removeSinglePulseLaunch', data.uuid);
          break;
        default:
          break;
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
